import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectComponent from '../../../core/components/select/SelectComponent';
import { FontTypeEnum } from '../textSettingsTypes';
import { textSettingsChangeFontType } from '../state/controller';
import { AppStateTypes } from '../../../store/appStateTypes';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';

const FontTypeContainer = () => {
  const dispatch = useDispatch();

  const options = Object.values(FontTypeEnum).map((fontType) => ({
    text: fontType,
    value: fontType,
  }));

  const { fontType } = useSelector((state: AppStateTypes) => state.textSettings);

  const onChange = (value: string) => {
    dispatch(textSettingsChangeFontType(value));
  };

  return (
        <PanelSubSectionComponent>
            <p>Выберите шрифт</p>
            <SelectComponent onChange={onChange} defaultValue={fontType} options={options} />
        </PanelSubSectionComponent>
  );
};

export default FontTypeContainer;
